import Button2 from "../../../Button/Button2";
import ListOption from "../EditAutomations/ListOption";
import { RuleProvider, useRule } from "./RuleReducer";
import classes from '../CreateRule/SelectOutputs.module.css'
import { useEffect, useState } from "react";
import ProgressBar from "./ProgressBar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { FloatLabel } from "primereact/floatlabel";
import { Divider } from "primereact/divider";
import { Timeline } from "rsuite";

const ChooseWhatAdvRule = ({ navigate, createRule }) => {

    const { state, dispatch } = useRule(RuleProvider);
    // let finished = false;
    const [progress, setProgress] = useState(100)
    const [finished, setFinished] = useState(true)

    //check if adv rule, if so, display chosen outputs individually with the 4 options on what each one should do?

    const [matchButtonText, setMatchButtonText] = useState("Match the state")
    const [opposeButtonText, setOpposeButtonText] = useState("Oppose the state")
    const [toggleButtonText, setToggleButtonText] = useState("Toggle state")
    const [statusText, setStatusText] = useState([])

    const [createNameVisible, setCreateNameVisible] = useState(false)
    const [ruleName, setRuleName] = useState("")
    const [ruleDescription, setRuleDescription] = useState("")

    const [daysSelected, setDaysSelected] = useState(state.days_of_week)
    const Days = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];
    const [showTimeDialog, setShowTimeDialog] = useState(false)
    const [timeLength, setTimeLength] = useState(0)

    const [pendingSelection, setPendingSelection] = useState(null);

    const convertDaysOfTheWeek = () => {
        const selectedDayNames = daysSelected
            .slice()
            .sort((a, b) => a - b)
            .map(dayNumber => Days[dayNumber])
            .join(',');

        if (selectedDayNames === "Mon,Tues,Wed,Thur,Fri") {
            return "on weekdays";
        } else if (selectedDayNames === "Sat,Sun") {
            return "on weekends";
        } else {
            return "on " + selectedDayNames.split(',').join(', ');
        }
    }

    const HandleText = () => {
        let inputType;
        let inputRule;
        switch (state.inputType) {
            case 0:
                inputType = `${state.pinStatusOn}`;
                break;
            case 1:
                inputType = `${state.pinStatusOn} or ${state.pinStatusOff}`;
                break;
            case 2:
                inputType = `${state.pinStatusOff}`;
                break;
            case 3:
                inputType = `${state.pinStatusOn}`;
                inputRule = "will temporarily arm"
                break;
            case 4:
                inputType = `${state.pinStatusOn}`;
                inputRule = "will temporarily disarm"
                break;
            default:
                inputType = "unknown";
                break;
        }


        switch (state.inputRule) {
            case 0:
                if (state.isLock) {
                    inputRule = `will be disarmed`;
                } else {
                    inputRule = `will match ${state.pinName} state`;
                }

                break;
            case 1:
                if (state.isLock) {
                    inputRule = `will be armed`;
                } else {
                    inputRule = `will oppose ${state.pinName} state`;
                }
                break;
            case 2:
                if (state.isLock) {
                    inputRule = "will toggle state"
                } else {
                    inputRule = `will toggle`;
                }

                break;
        }

        if (state.isLock) {
            inputType = "opened"
        }
        if (state.isPulse) {
            inputType = `temporarily ${state.pinStatusOff}`
        }

        if (state.days_of_week.length < 7) {
            return `When ${state.pinName} is ${inputType} ${convertDaysOfTheWeek()}, ${statusText} `;
        } else {
            return `When ${state.pinName} is ${inputType}, ${statusText}`;
        }
    }

    useEffect(() => {
        if (state.isLock) {
            setMatchButtonText("Disarm")
            setOpposeButtonText("Arm")
            setToggleButtonText("Toggle state")
        }
    }, [])

    const HandleInputRuleSelected = (selection, value) => {
        console.log(selection)
        //finished = value
        //issue here - navigates to timer screen no matter the selection
        if (selection == 0 || selection == 1 || selection == 2) {
            dispatch({ type: "SET_INPUT_RULE", payload: selection })
            console.log("here")

            setFinished(true)
            setProgress(100)
            //save
        } else {
            console.log("here")
            dispatch({ type: "SET_INPUT_TYPE", payload: selection })
            dispatch({ type: "SET_INPUT_RULE", payload: 10 })
            setFinished(false)
            setProgress(80)
            //go to timer 
        }
    }

    const convertControlType = (controlType) => {
        switch (controlType) {
            case "MATCH":
                return "match"

            case "OPPOSE":
                return "oppose"

            case "TOGGLE":
                return "toggle"

        }
    }

    const OutputStateSelected = (type, pin) => {
        // If it's a TEMP option, store and open the dialog
        if (type === 1 || type === 3) {
            setPendingSelection({ type, pin });
            setShowTimeDialog(true);
            return; // do NOT apply action yet
        }

        applyOutputSelection(type, pin, null);
    };

    const applyOutputSelection = (type, pin, timeLength) => {
        const controlType =
            type === 0 ? "ARM" :
            type === 1 ? "TEMP_ARM" :
            type === 2 ? "DISARM" :
            type === 3 ? "TEMP_DISARM" :
            type === 4 ? "OPPOSE" :
            type === 5 ? "TOGGLE" :
            type === 6 ? "PULSE" :
            type === 7 ? "MATCH" : ""

        const updatedActions = state.actions.map(a =>
            (a.site_to === pin.DeviceUUID && a.target_output === String(pin.Pin))
                ? {
                    ...a,
                    control_type: controlType,
                    temporary_time_ms:
                        (type === 1 || type === 3)
                            ? timeLength * 60000
                            : 0
                }
                : a
        );

        console.log(updatedActions)

        dispatch({
            type: "SET_ADV_RULE_ACTION",
            payload: updatedActions
        });

        setStatusText(prev => {
            const index = prev.findIndex(msg => msg.startsWith(pin.pinName + " "));
            if (index !== -1) {
                const newArr = [...prev];
                newArr[index] = `${pin.pinName} will ${convertControlType(controlType)} ${state.pinName} state `;
                return newArr;
            }
            return [
                ...prev,
                `${pin.pinName} will ${convertControlType(controlType)} ${state.pinName} state `
            ];
        });
    };

    const handleTempConfirm = () => {
        if (!pendingSelection) return;

        applyOutputSelection(
            pendingSelection.type,
            pendingSelection.pin,
            timeLength // entered in dialog
        );

        setPendingSelection(null);
        setShowTimeDialog(false);
    };


    // const OutputStateSelected = (type, pin) => {
    //     // convert type to control_type string

    //     const controlType =
    //         type === 0 ? "ARM" :
    //             type === 1 ? "TEMP_ARM" :
    //                 type === 2 ? "DISARM" :
    //                     type === 3 ? "TEMP_DISARM" :
    //                         type === 4 ? "OPPOSE" :
    //                             type === 5 ? "TOGGLE" :
    //                                 type === 6 ? "PULSE"
    //                                     : "";

    //     const updatedActions = state.actions.map(a =>
    //         (a.site_to === pin.DeviceUUID && a.target_output === String(pin.Pin))
    //             ? { ...a, control_type: controlType, temporary_time_ms: (type === 1 || type === 3) ? timeLength * 60000 : 0 }
    //             : a
    //     );

    //     setStatusText(prev => {
    //         const index = prev.findIndex(msg => msg.startsWith(pin.pinName + " "));
    //         if (index !== -1) {
    //             const newArr = [...prev];
    //             newArr[index] = `${pin.pinName} will ${convertControlType(controlType)} ${state.pinName} state `;
    //             return newArr;
    //         } else {
    //             // Add new entry
    //             return [...prev, `${pin.pinName} will ${convertControlType(controlType)} ${state.pinName} state `];
    //         }
    //     });

    //     console.log(updatedActions)

    //     dispatch({
    //         type: "SET_ADV_RULE_ACTION",
    //         payload: updatedActions
    //     });
    // };


    const HandleNavigate = (direction) => {
        console.log(state.name)
        if (direction === "back") {
            navigate(2);
            return;
        } else {
            if (finished) {
                createRule(state.inputRule, state.selectedPinsToAffect, state)
            } else {
                navigate(4);
            }
        }
    };

    const createRuleDetails = () => {
        console.log(ruleName)
        dispatch({
            type: "SET_RULE_NAME",
            payload: ruleName
        });
        dispatch({
            type: "SET_RULE_DESCRIPTION",
            payload: ruleDescription
        });
        setCreateNameVisible(false)
    }

    useEffect(() => {
        if (state.name && createNameVisible === false) {
            HandleNavigate("next")
        }
    }, [state.name])

    useEffect(() => {

    }, [timeLength])

    return (
        <>
            <Dialog
                header="Please create a name and brief description for this rule"
                visible={createNameVisible}
                style={{ width: "40vw" }}
                onHide={() => setCreateNameVisible(false)}
            >
                <div>
                    <FloatLabel>
                        <InputText
                            value={ruleName}
                            onChange={(e) => setRuleName(e.target.value)}
                        />
                        <label htmlFor="ruleName">Name</label>
                    </FloatLabel>

                    <Divider type="solid" />
                    <br />
                    <FloatLabel>
                        <InputTextarea id="desc" value={ruleDescription} onChange={(e) => setRuleDescription(e.target.value)} rows={5} cols={30} />
                        <label htmlFor="ruleDesc">{"Description (optional)"}</label>
                    </FloatLabel>
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        label="Create rule"
                        severity="success"
                        disabled={ruleName === ""}
                        onClick={createRuleDetails}
                    />
                </div>
            </Dialog>

            <Dialog
                header="Fow how long?"
                visible={showTimeDialog}
                style={{ width: "40vw" }}
                onHide={() => setShowTimeDialog(false)}
            >
                <div className="flex flex-column gap-2">
                    <label htmlFor="for">For </label>
                    <InputText
                        value={timeLength}
                        onChange={(e) => setTimeLength(e.target.value)}
                    />
                    <label htmlFor="minutes"> minutes</label>
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        label="Set length"
                        severity="success"
                        disabled={timeLength == 0}
                        onClick={() => handleTempConfirm()}
                    />
                </div>
            </Dialog>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px" }}>
                <ProgressBar progress={progress} />
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "20px" }}>
                    <button className={classes.nextButton} onClick={() => HandleNavigate("back")} >{"<"}</button>
                    {/* <ListOption optionText={HandleText()} propsClassName={classes.infoBox} /> */}
                    <button className={classes.nextButton} onClick={() => setCreateNameVisible(true)} >{">"}</button>
                </div>
                <h3 style={{ color: "#6e6e6e" }}>What will the switches do when the rule triggers?</h3>
                <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px", marginBottom: "20px" }}>
                    {state.selectedPinsToAffect.map((pin, index) => {
                        const action = state.actions.find(
                            a => a.site_to === pin.DeviceUUID && a.target_output === String(pin.Pin)
                        );
                        console.log(pin)
                        const selectedType =
                            action?.control_type === "ARM" ? 0
                            : action?.control_type === "TEMP_ARM" ? 1
                            : action?.control_type === "DISARM" ? 2
                            : action?.control_type === "TEMP_DISARM" ? 3
                            : action?.control_type === "OPPOSE" ? 4
                            : action?.control_type === "TOGGLE" ? 5
                            : action?.control_type === "PULSE" ? 6
                            : action?.control_type === "MATCH" ? 7 
                            : null 

                        return (
                            <>
                                <h3>{`${pin.pinName} will`}</h3>
                                {(pin.type !== "PULSE" && pin.type !== "VIRTUAL_PULSE") &&
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                                         <Button2
                                            style={{
                                                minWidth: "350px",
                                                minHeight: "50px",
                                                backgroundColor: selectedType === 7 ? "var(--Primary-Color)" : undefined,
                                                color: selectedType === 7 ? "white" : undefined,
                                                border: selectedType === 7 ? "2px solid lightblue" : undefined
                                            }}
                                            onClick={() => OutputStateSelected(7, pin)}
                                        >
                                            {`Match ${state.selectedRulePin.pinName} state`}
                                        </Button2>
                                        
                                        <Button2
                                            style={{
                                                minWidth: "350px",
                                                minHeight: "50px",
                                                backgroundColor: selectedType === 0 ? "var(--Primary-Color)" : undefined,
                                                color: selectedType === 0 ? "white" : undefined,
                                                border: selectedType === 0 ? "2px solid lightblue" : undefined
                                            }}
                                            onClick={() => OutputStateSelected(0, pin)}
                                        >
                                            {pin.actionOneOffLabel || "Arm"}
                                        </Button2>

                                        {/* Temp Arm BUTTON */}
                                        <Button2
                                            style={{
                                                minWidth: "350px",
                                                minHeight: "50px",
                                                backgroundColor: selectedType === 1 ? "var(--Primary-Color)" : undefined,
                                                color: selectedType === 1 ? "white" : undefined,
                                                border: selectedType === 1 ? "2px solid lightblue" : undefined
                                            }}
                                            onClick={() => { OutputStateSelected(1, pin); setShowTimeDialog(true) }}
                                        >
                                            {`Temporarily ${pin.actionOneOffLabel || "Arm"}`}
                                        </Button2>

                                        {/* DISARM BUTTON */}
                                        <Button2
                                            style={{
                                                minWidth: "350px",
                                                minHeight: "50px",
                                                backgroundColor: selectedType === 2 ? "var(--Primary-Color)" : undefined,
                                                color: selectedType === 2 ? "white" : undefined,
                                                border: selectedType === 2 ? "2px solid lightblue" : undefined
                                            }}
                                            onClick={() => OutputStateSelected(2, pin)}
                                        >
                                            {pin.actionOneOnLabel || "Disarm"}
                                        </Button2>

                                        {/* TEMP DISARM BUTTON */}
                                        <Button2
                                            style={{
                                                minWidth: "350px",
                                                minHeight: "50px",
                                                backgroundColor: selectedType === 3 ? "var(--Primary-Color)" : undefined,
                                                color: selectedType === 3 ? "white" : undefined,
                                                border: selectedType === 3 ? "2px solid lightblue" : undefined
                                            }}
                                            onClick={() => { OutputStateSelected(3, pin); setShowTimeDialog(true) }}
                                        >
                                            {`Temporarily ${pin.actionOneOnLabel || "Disarm"}`}
                                        </Button2>

                                        {/* OPPOSE BUTTON */}
                                        {/* <Button2
                                        style={{
                                            minWidth: "350px",
                                            minHeight: "50px",
                                            backgroundColor: selectedType === 4 ? "var(--Primary-Color)" : undefined,
                                            color: selectedType === 4 ? "white" : undefined,
                                            border: selectedType === 4 ? "2px solid lightblue" : undefined
                                        }}
                                        onClick={() => OutputStateSelected(4, pin)}
                                    >
                                        {`Oppose ${state.pinName} state`}
                                    </Button2> */}

                                        {/* TOGGLE BUTTON */}
                                        <Button2
                                            style={{
                                                minWidth: "350px",
                                                minHeight: "50px",
                                                backgroundColor: selectedType === 5 ? "var(--Primary-Color)" : undefined,
                                                color: selectedType === 5 ? "white" : undefined,
                                                border: selectedType === 5 ? "2px solid lightblue" : undefined
                                            }}
                                            onClick={() => OutputStateSelected(5, pin)}
                                        >
                                            {`Toggle`}
                                        </Button2>
                                    </div>


                                }

                                {(pin.type == "PULSE" || pin.type == "VIRTUAL_PULSE") &&
                                    //<div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                                    <Button2 style={{
                                        minWidth: "350px",
                                        minHeight: "50px",
                                        backgroundColor: selectedType === 6 ? "var(--Primary-Color)" : undefined,
                                        color: selectedType === 6 ? "white" : undefined,
                                        border: selectedType === 6 ? "2px solid lightblue" : undefined
                                    }}
                                        onClick={() => OutputStateSelected(6, pin)}
                                    >
                                        {`Temporarily ${pin.actionOneOnLabel || "disarm"} `}
                                    </Button2>
                                    //</div>
                                }
                            </>
                        )
                    })}
                </ul >
            </div>
        </>
    )
}

export default ChooseWhatAdvRule;